export default __webpack_public_path__ + "static/media/maypay_icon_x_red.b1aa0479.svg";